import {
  CLINIC_STATUS,
  formatLocation,
  getClinicStatus,
  getClinicType,
  getTierTitle,
} from "./clinicFields";

export const SORT_ORDER = { ASC: "asc", DESC: "desc" };
export const DEFAULT_SORT = { orderBy: "rowNumber", order: SORT_ORDER.ASC };

const STATUS_RANK = {
  [CLINIC_STATUS.NEW]: 0,
  [CLINIC_STATUS.ACTIVE]: 1,
  [CLINIC_STATUS.INACTIVE]: 2,
};

const SORT_VALUE_GETTERS = {
  rowNumber: (clinic) => clinic.rowNumber,
  title: (clinic) => clinic.title,
  shortName: (clinic) => clinic.shortName,
  location: (clinic) => [clinic.city, formatLocation(clinic)].join(" "),
  email: (clinic) => clinic.email,
  phoneNumber: (clinic) => clinic.phoneNumber,
  tier: (clinic, tiersById) => getTierTitle(clinic, tiersById),
  clinicType: (clinic) => getClinicType(clinic),
  status: (clinic) => STATUS_RANK[getClinicStatus(clinic)],
};

export const SORTABLE_COLUMNS = Object.keys(SORT_VALUE_GETTERS);

function isEmpty(value) {
  return value === null || value === undefined || value === "";
}

function compareValues(a, b) {
  if (typeof a === "number" && typeof b === "number") return a - b;
  return String(a).localeCompare(String(b), "hr", {
    sensitivity: "base",
    numeric: true,
  });
}

/**
 * Returns a sorted copy of `clinics`. Clinics with no value for the sorted
 * column always go last, whichever direction is chosen. Unknown columns fall
 * back to the row number.
 */
export function sortClinics(clinics, { orderBy, order }, tiersById) {
  const getValue =
    SORT_VALUE_GETTERS[orderBy] ?? SORT_VALUE_GETTERS[DEFAULT_SORT.orderBy];
  const direction = order === SORT_ORDER.DESC ? -1 : 1;

  return [...clinics].sort((first, second) => {
    const a = getValue(first, tiersById);
    const b = getValue(second, tiersById);
    if (isEmpty(a) || isEmpty(b)) return isEmpty(a) - isEmpty(b);
    return compareValues(a, b) * direction || first.rowNumber - second.rowNumber;
  });
}
